import { t } from "i18next";
import type { Observable } from "rxjs";
import { Subject } from "rxjs";

type ToastType = "success" | "info" | "warning" | "error";

export interface ToastItem {
    type: ToastType;
    title: string | undefined;
    description: string | undefined;
}

export class ToastManagerRepository {
    private static _toastSubject = new Subject<ToastItem>();
    static toast: Observable<ToastItem> = ToastManagerRepository._toastSubject;

    static success(
        description?: string,
        title: string = t("component:toastManager.defaultSuccess"),
    ): void {
        ToastManagerRepository._toastSubject.next({
            type: "success",
            title: title,
            description: description,
        });
    }

    static error(
        description: string,
        title: string = t("component:toastManager.defaultError"),
    ): void {
        ToastManagerRepository._toastSubject.next({
            type: "error",
            title: title,
            description: description,
        });
    }

    static info(description: string, title?: string): void {
        ToastManagerRepository._toastSubject.next({
            type: "info",
            title: title,
            description: description,
        });
    }

    static warning(description: string, title?: string): void {
        ToastManagerRepository._toastSubject.next({
            type: "warning",
            title: title,
            description: description,
        });
    }
}
